import { X } from "lucide-react";

interface ClearFiltersProps {
  label: string;
  onClick: () => void;
}

/** "Clear filters" text button. Single source across the Org/People/Roles/Invites toolbars. */
export function ClearFilters({ label, onClick }: ClearFiltersProps) {
  return (
    <button
      type="button"
      className="flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium text-muted-foreground hover:text-foreground"
      onClick={onClick}
    >
      <X className="h-3 w-3" />
      {label}
    </button>
  );
}
